// removed by extract-text-webpack-plugin
module.exports = {"haplotype-card":"haplotype-card","card-title":"card-title","title-indicator":"title-indicator","title":"title","title-wrapper":"title-wrapper","upload-wrapper":"upload-wrapper","file-name":"file-name","upload-label":"upload-label","confirm-btn":"confirm-btn","card-body":"card-body"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/HaplotypeCard/index.scss
// module id = 1383
// module chunks = 0